import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Box } from "@mui/material";
import { useMediaQuery } from "react-responsive";
import { Navigation } from "swiper/modules";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Swiper as SwiperType } from "swiper/types";
import "swiper/css";
import "swiper/css/navigation";
import { IStoreSlot } from "../../../store/models/slots/typing/slot.interface";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../store/hooks/store.hooks";
import { getTSlots } from "../../../store/models/slots/slot.thunk";
import { SlotCard } from "../SlotCard/SlotCard";
import arrow from "../../../assets/icons/arrow-down.svg";
import "./slotsSection.css";
import { LobbySlotsSelector } from "../LobbySlotsSection/LobbySlots.selector";
import { scrollTop } from "../../../utils/scrollTop";

interface ISlotSectionProps {
  action:
    | "popular"
    | "popular_live"
    | "popular_crash"
    | "recommended"
    | "bonus_buy"
    | "new"
    | "slots"
    | "live"
    | "crash_games"
    | "roulette"
    | "card_games"
    | "jackpots"
    | "mega_ways"
    | "animals"
    | "fruits"
    | "seven"
    | "books";
  src: string;
  attribute: string;
  object: {
    [key: string]: string | number | boolean | undefined;
    page: number;
    provider: number | undefined;
  };
  path?: string;
}
export const SlotsSection = ({
  action,
  src,
  object,
  attribute,
  path = "/lobby/slots",
}: ISlotSectionProps) => {
  const slotsData = useAppSelector(LobbySlotsSelector(attribute));
  const favorites = useAppSelector(({ slots }) => slots.favouriteGames);
  const games: IStoreSlot[] = slotsData.games;
  const { t } = useTranslation();
  const navigator = useNavigate();
  const dispatch = useAppDispatch();
  useEffect(() => {
    async function fetch() {
      if (!games.length) {
        await dispatch(getTSlots({ ...object, attribute }));
      }
    }
    fetch();
    scrollTop();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const [isLastSlide, setIsLastSlide] = useState(false);

  const handleSlideChange = (swiper: SwiperType) => {
    if (swiper.isEnd) {
      setIsLastSlide(true);
    } else {
      setIsLastSlide(false);
    }
  };
  const isMobile = useMediaQuery({ maxWidth: 599.98 });
  return (
    <Box className="slots-section">
      <Swiper
        modules={[Navigation]}
        onSlideChange={handleSlideChange}
        spaceBetween={10}
        slidesPerView={3}
        navigation={{
          disabledClass: "slots-section-disabled",
          prevEl: ".slots-section-prev",
          nextEl: ".slots-section-next",
        }}
        className="slots-section__swiper"
        breakpoints={{
          768: {
            slidesPerView: 4.5,
          },
          1024: {
            slidesPerView: 6.5,
          },
          1760: {
            slidesPerView: 7.5,
          },
        }}
      >
        {[
          ...games.map((game) => {
            return (
              <SwiperSlide key={`slots_${game.id}`}>
                <SlotCard
                  cardId={game.id}
                  src={game.image_url}
                  title={game.title}
                  top={game.popular}
                  recs={game.recommended}
                  new={game.new}
                  live={game.animals}
                  disabled={!game.available}
                  favorites={favorites}
                />
              </SwiperSlide>
            );
          }),
          isMobile && (
            <SwiperSlide key={`slots_${action}_last`}>
              <Box
                className="slots-section__last"
                onClick={() => {
                  navigator(path);
                }}
              >
                <Box className="slots-section__primary-button">
                  {t("slots.all")}
                </Box>
              </Box>
            </SwiperSlide>
          ),
        ]}
        <Box className="slots-section-prev">
          <img src={arrow} alt="Prev" />
        </Box>
        <Box className="slots-section-next">
          <img src={arrow} alt="Next" />
        </Box>
        <Box className="slots-section__heading">
          <img src={src} alt={action} />
          {t(`main.menuItems.${action}`)}
        </Box>
        {!isLastSlide && !isMobile && (
          <Box className="slots-section__end"></Box>
        )}
        {!isMobile && (
          <Box
            className="slots-section__all"
            onClick={() => {
              navigator(path);
            }}
          >
            {t("slots.all")}
            <img src={arrow} alt="Next" />
          </Box>
        )}
      </Swiper>
    </Box>
  );
};
